<template>
  <a
    v-if="item.tags.has_invoice_number === 2"
    :href="url"
    target="_blank"
    v-html="get_print_html(item.tags.has_invoice_number)"
    style="cursor: pointer"
  ></a>
  <b-spinner v-else-if="spinner" variant="success"></b-spinner>
  <a
    v-else
    @click="actions()"
    v-html="get_print_html(item.tags.has_invoice_number)"
    style="cursor: pointer"
  >
  </a>
</template>

<script>
import axios from "axios";

export default {
  name: "Nfe",
  props: ["documents", "checkFaturador", "item"],
  data() {
    return {
      url: null,
      spinner: false,
    };
  },
  methods: {
    actions() {
      var id = [this.item.id];
      this.spinner = true;
      axios
        .post("/api/documents/put_invoice", { ids: id, has_invoice_number: 2 })
        .then((response) => {
          window.open(this.url, "_blank");
          this.spinner = false;
          return;
        })
        .catch((error) => {
          this.spinner = false;
          swal({
            title: "Ops!",
            text: "Parece que tem algo de errado com a etiqueta, depende da etiqueta para gerar a nota...",
            type: "error",
          });
          return;
        });
    },
    nfe() {
      var docs = this.documents;
      for (const key in docs) {
        var doc = docs[key];
        for (const k in doc) {
          if (this.checkFaturador) {
            if (doc["type"] == "invoice_pdf") {
              this.url = doc["url"];
            }
          } else {
            if (doc["type"] == "invoice") {
              this.url = doc["url"];
            }
          }
        }
      }
    },
    get_print_html(key) {
      var icon;
      var title;

      if (key == 0) {
        title = this.$t("Gerar Nfe.");
        icon = '<i class="fas fa-scroll ml-2" title="' + title + '"></i>';
      }

      if (key == 1) {
        title = this.$t("Nfe disponível para impressão");
        icon =
          '<i class="fas fa-scroll ml-2 text-blue" title="' + title + '"></i>';
      }

      if (key == 2) {
        title = this.$t("Nfe Impressa");
        icon =
          '<i class="fas fa-scroll ml-2 text-green" title="' + title + '"></i>';
      }

      if (key == 3) {
        title = this.$t("Erro na etiqueta");
        icon =
          '<i class="fas fa-scroll ml-2 text-red" title="' + title + '"></i>';
      }

      return icon;
    },
  },
  beforeMount() {
    this.nfe();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/ActionTable/Nfe.vue